import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type EvaluationFormValues = {
  position: number;
  name: string;
  duration: number;
};

export const evaluationValidationSchema = yup.object({
  position: yup
    .number()
    .typeError("Le numéro d'exercice doit être un nombre")
    .required("Le numéro d'exercice est obligatoire.")
    .min(1, "Le numéro d'exercice doit être supérieur à 0."),
  name: yup.string().required('Le nom est obligatoire.'),
  duration: yup
    .number()
    .typeError('La durée doit être un nombre')
    .required('La durée est obligatoire.'),
});

export const useEvaluationForm = () => {
  const { register, handleSubmit, errors, setValue, reset, getValues } =
    useFormHandler<EvaluationFormValues>(evaluationValidationSchema);

  return { register, handleSubmit, errors, setValue, reset, getValues };
};
